import { SERVICES_DETAIL } from './servicesDetail';

export const CLINIC_INFO = {
  name: 'Noble Dental Surgery',
  tagline: 'Your Smile, Our Passion',
  phone: '+91 9815105244',
  email: 'noble@nobledentalsurgery.com',
  address: 'Noble Dental Surgery, 1-R, Model Town, opp. Hotel Presidency Hoshiarpur-146001',
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3400.734583970061!2d75.89536137609888!3d31.531448946593844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391afd0b28cb8ac7%3A0x9bbfad965c57cf61!2sNoble%20Dental%20Surgery!5e0!3m2!1sen!2sin!4v1779700836379!5m2!1sen!2sin",
  whatsapp: '9815105244',
  instagram: 'https://www.instagram.com/noble_dental_surgery?igsh=MTQ1eHJ4ejFraHVuNQ==',
  facebook: 'https://www.facebook.com/share/1HL9hcSJBh/?mibextid=wwXIfr',
  google: 'https://share.google/Ho3YxjLifRj1MytUM',
  hours: [
    { day: 'Summers', time: '10:00 AM – 6:30 PM' },
    { day: 'Winters', time: '10:00 AM – 6:00 PM' },
    { day: 'Sunday', time: 'Closed' },
  ],
};

export const SERVICES = SERVICES_DETAIL.map((service, index) => ({
  id: index + 1,
  serviceId: service.id,
  title: service.title,
  description: service.paragraphs[0],
  icon: service.icon,
  color: service.color,
  duration: service.duration,
}));
export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Amitaj Bangar',
    role: 'Software Engineer',
    review: "Hi friends, I'm from USA. Some of our family friends told me about this Dental clinic because I needed some dental cleaning and crowning also. In my first I get fully satisfied. So friends I'm very thankful of here's staff. If there would be more than five stars I would tap on that. Noble dental surgery clinic's staff is very experienced, helpful and cooperative. Please try once here and than u will be back again for next service. Thank you.",
    rating: 5,
    treatment: 'Teeth Whitening & Crown Placement',
    avatar: 'AB',
  },
  {
    id: 2,
    name: 'Jaskaran Bains',
    role: 'Business Owner',
    review: "Got my crown done by Dr. Aarti. She was very kind and patient. Even kept asking are you sure before sending me on my way. Great place for patient care and even put a rush on my appointment because I was flying out early in the week. Highly recommend in terms of patient care and I don't feel pressured to make a decision.",
    rating: 5,
    treatment: 'Crown Placement',
    avatar: 'JB',
  },
  {
    id: 3,
    name: 'FBB Burrito',
    role: 'Teacher',
    review: 'I was referred to this clinic by my relatives, and I must admit that their recommendation was spot on. The clinic boasts a serene and spotless environment, which significantly reduces anxiety. I am thoroughly impressed. I strongly recommend their dental treatment services. Thank you for the efficient, painless, and outstanding treatment I received. It is deeply appreciated!',
    rating: 5,
    treatment: 'Dental Implants',
    avatar: 'FB',
  },
  {
    id: 4,
    name: 'Shalini R',
    role: 'Mother',
    review: 'The service provided by the Noble dental surgery Hoshiarpur is one of the finest we can get all over the city. Excellent infrastructure and the treatment skills shows dedication, passion and love for the patients specially Dr. Aatish is the best by far as she treated my son’s cavity issues so well. The way she speaks ,explained the procedure and make my 8 yrs old comfortable throughout the treatment is really commendable. She is my son’s favourite dentist.',
    rating: 5,
    treatment: 'Pediatric Dentistry',
    avatar: 'SR',
  },
  {
    id: 5,
    name: 'Manraj Thiara',
    role: 'Marketing Manager',
    review: 'I had a wonderful experience getting my braces here! The staff was incredibly polite, professional, and always made me feel comfortable. Their attention to detail and patient care truly stood out. Highly recommend this clinic for anyone seeking quality dental treatment!',
    rating: 5,
    treatment: 'Braces & Aligners',
    avatar: 'MT',
  },
];

export const FAQS = [
  {
    q: 'How often should I visit the dentist?',
    a: 'We recommend visiting every 6 months for a routine checkup and cleaning. However, patients with specific dental conditions may need more frequent visits.',
  },
  {
    q: 'Is teeth whitening safe?',
    a: 'Yes, professional teeth whitening at Noble Dental is completely safe. We use clinically approved whitening agents and customized trays to protect your gums and enamel.',
  },
  {
    q: 'Do you offer payment plans or EMI?',
    a: 'Yes, we offer flexible payment options including EMI through partner banks and 0% financing on major treatments. Ask our front desk for more details.',
  },
  {
    q: 'How long do dental implants last?',
    a: 'With proper care, dental implants can last a lifetime. The crown typically needs replacement every 10–15 years depending on wear and care.',
  },
  {
    q: 'Is root canal treatment painful?',
    a: 'Modern root canal therapy is virtually painless. We use advanced anesthesia and sedation techniques so you remain completely comfortable throughout the procedure.',
  },
  {
    q: 'What age should children first visit the dentist?',
    a: 'The first dental visit should be around the child\'s first birthday or within 6 months of the first tooth appearing. Early visits help establish good habits and prevent problems.',
  },
  {
    q: 'Do you handle dental emergencies?',
    a: 'Yes! We have emergency dental slots available. Call us immediately for severe toothaches, knocked-out teeth, or broken dental work and we\'ll see you as soon as possible.',
  },
];

export const WHY_CHOOSE_US = [
  {
    title: 'Expert Specialists',
    description: 'Our team of certified dental specialists brings 15+ years of combined experience.',
    icon: '🏆',
  },
  {
    title: 'Advanced Technology',
    description: 'Digital X-rays, 3D scanning, and the latest dental equipment for precise treatment.',
    icon: '🔬',
  },
  {
    title: 'Pain-Free Treatment',
    description: 'Modern anesthesia and sedation techniques ensure maximum comfort throughout.',
    icon: '💊',
  },
  {
    title: 'Transparent Pricing',
    description: 'No hidden costs. Get a detailed treatment plan with pricing before we begin.',
    icon: '💰',
  },
  {
    title: 'Emergency Care',
    description: 'Dental emergencies don\'t wait—neither do we. Same-day emergency appointments available.',
    icon: '🚨',
  },
  {
    title: 'Sterilized Environment',
    description: 'Strict sterilization and infection control protocols for your complete safety.',
    icon: '🛡️',
  },
];
